// AIDEV-NOTE: Route-aware dialog wrapper. Mounts via React Router child route,
// always open while mounted, navigates to returnPath on close (ESC, overlay, close button).
// Use for modals that should be linkable/bookmarkable. For ephemeral modals, use SPADialog + useModalManager.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import SPADialog from './SPADialog';

interface RoutedSPADialogProps {
  children: React.ReactNode;
  returnPath?: string;
}

const RoutedSPADialog = ({ children, returnPath = '..' }: RoutedSPADialogProps) => {
  const navigate = useNavigate();

  return (
    <SPADialog
      open
      onOpenChange={(open) => { if (!open) navigate(returnPath); }}
    >
      {children}
    </SPADialog>
  );
};

export default RoutedSPADialog;
